/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuildInfo } from '../../models/build-info';

export interface MainControllerGetBuildInfo$Params {
}

export function mainControllerGetBuildInfo(http: HttpClient, rootUrl: string, params?: MainControllerGetBuildInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildInfo>> {
  const rb = new RequestBuilder(rootUrl, mainControllerGetBuildInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuildInfo>;
    })
  );
}

mainControllerGetBuildInfo.PATH = '/buildInfo';
